/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhoneNumberRequest
 */
export interface UpdatePhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneNumberRequest
     */
    phone: string;
    /**
     * Whether the user allows transactional SMS. Absent when the consent was not collected.
     * @type {boolean}
     * @memberof UpdatePhoneNumberRequest
     */
    isTransactionalSmsAllowed?: boolean;
}

/**
 * Check if a given object implements the UpdatePhoneNumberRequest interface.
 */
export function instanceOfUpdatePhoneNumberRequest(value: object): value is UpdatePhoneNumberRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function UpdatePhoneNumberRequestFromJSON(json: any): UpdatePhoneNumberRequest {
    return UpdatePhoneNumberRequestFromJSONTyped(json, false);
}

export function UpdatePhoneNumberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhoneNumberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'isTransactionalSmsAllowed': json['isTransactionalSmsAllowed'] == null ? undefined : json['isTransactionalSmsAllowed'],
    };
}

export function UpdatePhoneNumberRequestToJSON(value?: UpdatePhoneNumberRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phone': value['phone'],
        'isTransactionalSmsAllowed': value['isTransactionalSmsAllowed'],
    };
}

